import { section } from "@/neon";
import { qs, qsa, toggle, listen } from "@fluorescent/dom";

import productForm from "@/components/productForm";
import {
  optionButtons,
  quantityInput,
  variantAvailability,
  giftCardRecipient,
} from "@/lib/product";
import Media from "@/lib/media";
import variantPopup from "@/components/variantPopup";
import reviews from "@/components/reviews";
import accordion from "@/components/accordion";
import { animateProduct } from "@/lib/animation";

const {
  strings: { products: strings },
} = theme;

const selectors = {
  swatches: "[data-product-swatches]",
  chips: "[data-product-chips]",
  quantityInput: ".product-form__quantity",
  socialSharing: ".share",
  productDetailsWrapper: ".product__meta-inner",
  productDescription: ".product__description",
  productForm: "[data-product-form]",
};

section("featured-product", {
  onLoad() {
    this.media = Media(this.container);
    const productFormContainer = this.container.querySelector(
      selectors.productForm
    );

    if (productFormContainer) {
      this.productForm = productForm(productFormContainer, {
        isProductPage: false,
        isFeaturedProduct: true,
        container: this.container,
      });
      this.optionButtons = optionButtons(
        qsa("[data-option-buttons]", this.container)
      );
      this.quantityInput = quantityInput.call(this, selectors.quantityInput);
      this.variantPopup = variantPopup(this.container);
    }

    this.productDetails = this.container.querySelector(
      selectors.productDetailsWrapper
    );

    this.animateProduct = animateProduct(this.container);

    // Here we check if the merchant added a product reviews section or not
    const reviewsTemplate = this.container.querySelector(
      ".product-reviews-template"
    );
    const reviewsDrawer = this.container.querySelector("[data-reviews-drawer]");
    let reviewsIsDrawer = false;

    if (reviewsTemplate && reviewsDrawer) {
      reviewsDrawer.classList.add("reviews-flyout--active");
      reviewsDrawer.appendChild(reviewsTemplate.content.cloneNode(true));
      reviewsIsDrawer = true;
    }

    window.SPRCallbacks = {};

    window.SPRCallbacks.onReviewsLoad = () => {
      if (!this.reviews) {
        this.reviews = reviews(this.container, reviewsIsDrawer);
      }
    };

    this.accordions = this.container.querySelectorAll(selectors.accordion);
    this.accordions.forEach(item => {
      if (!item.classList.contains("accordion--active")) {
        accordion(item);
      }
    });

    this.socialButtons = qsa("[data-social-share]", this.container);

    this.socialButtonsClick = listen(this.socialButtons, "click", e => {
      toggle(e.target, "active");
      const sub = qs(".product__share-icons", e.target);

      sub.setAttribute("aria-hidden", !e.target.classList.contains("active"));
    });

    // Handle dynamic variant options
    this.variantAvailability = variantAvailability(this.container);

    this.giftCardRecipient = giftCardRecipient(this.container);
  },

  onUnload() {
    this.quantityInput && this.quantityInput();
    this.productForm && this.productForm.unload();
    this.variantPopup && this.variantPopup.unload();
    this.optionButtons.destroy();
    this.variantAvailability?.unload();
    this.animateProduct?.destroy();
    this.giftCardRecipient?.unload();
  },
});
